import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  BulkPriceChangeItem,
  ChangeBundlePricePayload,
  changeBundlePrice,
  changeBundlePricesBulk,
} from "../services/change-bundle-price";

export function useChangeBundlePrice() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      payload,
    }: {
      id: string;
      payload: ChangeBundlePricePayload;
    }) => changeBundlePrice(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bundles"] });
    },
  });
}

export function useChangeBundlePricesBulk() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (changes: BulkPriceChangeItem[]) =>
      changeBundlePricesBulk(changes),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bundles"] });
    },
  });
}
